/**
 * TimelineColumnRow — `timeline[column]` layout. Day/week event
 * columns. Provides the `timeline` slot.
 */
import { LayoutRow } from "./layout-row.ts";
import { TimedGridConfig } from "./timed-grid-config.ts";

/** The `timeline[column]` layout row: day and week event columns, providing the `timeline` slot. */
export class TimelineColumnRow extends LayoutRow {
  // Distinct from TimelineRowRow — they are NOT interchangeable.

  /**
   * Timed-grid layout config (hours window / timezone / style / view) read
   * from this layout row's OWN attribute bag. A standalone `timeline[column]`
   * (no calendar alias) owns its window directly — the same config the
   * `calendar-body` body resolves, sourced purely from the bound row.
   */
  timedConfig(): TimedGridConfig {
    return TimedGridConfig.fromAttributes(
      this.attributes() ?? {},
    );
  }
}
